import React, { Component } from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import OldRegs from './OldRegs';
import UserDataDisplay from './UserDataDisplay';

class UserDataPopup extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            
         }
    }

    componentDidMount(){        
    }

    render() { 
        return ( 
            <Tabs defaultActiveKey="data" id="uncontrolled-tab-example" className="mb-3">
                <Tab eventKey="data" title="Adatok">
                    <UserDataDisplay userData={this.props.userData}></UserDataDisplay>
                </Tab>
                <Tab eventKey="registrations" title="Korábbi regisztrációk">
                    <OldRegs userData={this.props.userData} allRegs={this.props.allRegs}></OldRegs>
                </Tab>
            </Tabs>);
    }
   
}
 
export default UserDataPopup;